import gql from 'graphql-tag';

const query = gql`
  query unsubscribeChallenge {
    unsubscribeChallenge {
      algorithm
      challenge
      maxnumber
      salt
      signature
    }
  }
`;

/** A fresh proof-of-work challenge. Never cached: each answer is accepted once. */
export default function unsubscribeChallenge({ apollo }) {
  return apollo.query({ query, fetchPolicy: 'no-cache' });
}
